import { InitiativeCreationStep } from '@app/pages/dashboard/initiative/shared/workflow'
import { NotificationFrequency } from '@schema/user'
import { InitiativeUserRole, NumberOfHomes } from 'schema/initiative'
import { PlotApplicationStatus } from 'schema/plot'
import { PhaseType } from '@schema/phase'

type Translation<T extends string | number | symbol> = {
  [K in T]: string
}

export const phaseTranslations: Translation<PhaseType> = {
  idea: 'Idea phase',
  location: 'Location phase',
  design: 'Desing phase',
  construction: 'Construction phase',
  living: 'Living phase',
} as const

export const plotApplicationStatusesTranslations: Translation<PlotApplicationStatus> =
  {
    applicationOpen: 'Application open',
    applicationClosed: 'Application closed',
    inPreparation: 'In preparation',
  } as const

export const initiativeUserRoleTranslation: Translation<InitiativeUserRole> = {
  owner: 'Initiativetaker',
  admin: 'Admin',
  member: 'Member',
  applicant: 'Applicant',
  follower: 'Follower',
} as const

// Note: AgeCategory, HousingTypePreference, OwnershipPreference are now schema entities
// and no longer enum types. These translations are kept for reference but not type-safe.

// Note: SpaceSizePreference and InvolvementPreference are now schema entities
// and no longer enum types. These translations are kept for reference but not type-safe.

export const notificationFrequencyTranslation: Translation<NotificationFrequency> =
  {
    weekly: 'Weekly',
    fortnightly: 'Fortnightly',
    monthly: 'Monthly',
    never: 'Never',
  } as const

export const initiativePhaseNameTranslation: Translation<PhaseType> = {
  idea: 'Idea phase',
  location: 'Location phase',
  design: 'Design phase',
  construction: 'Construction phase',
  living: 'Living phase',
} as const

export const initiativePhaseDescriptionTranslation: Translation<PhaseType> = {
  idea: "Your initiative is in a very early stage and you're looking for your crowd.",
  location:
    'You are professional group, you are registered at KVK and looking for a plot.',
  design: 'You are working on the design and might already have a plot.',
  construction:
    "You've jumped through all the hoops and now you're building your dream home.",
  living: 'You live in a realized and completed project.',
} as const

export const initiativeCreationStepTitleTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: 'Which phase your initiative is in?',
    mainDetails: 'Initiative details',
    pageContent: 'Describe your vision',
    livingParameters: 'How do you want to live?',
    membersParameters: 'Your members',
    legalInfo: 'Legal',
    amenities: 'Ameneties',
    contactDetails: 'Contact details',
    callSchedule: "One last step and you're done",
    finish: 'You are done!',
  } as const

export const initiativeCreationStepDescriptionTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: null,
    mainDetails: null,
    pageContent: null,
    livingParameters: null,
    membersParameters: null,
    legalInfo: null,
    amenities: null,
    contactDetails: null,
    callSchedule:
      "CrowdBuilding's team wants to get in touch with you to learn more about your initiative. Select the time that works best for you.",
    finish:
      'Once we have spoken, your initiative will be online. Interested in what to do next? Read more in our KnowledgeHub and E-learnings.',
  } as const

export const humberOfHomesTranslation: Translation<NumberOfHomes> = {
  lessThan5: '1-4',
  from5To10: '5-10',
  from11to30: '11-30',
  moreThan30: '30+',
} as const
